/**
 * Returns a random element from the given array.
 * @param {T[]} items - The array from which a random element will be selected.
 * @return {T} A random element from the array.
 */
export function getRandomItem<T>(items: T[]): T {
    if (items.length === 0) {
        throw new Error("Cannot get a random element from an empty array.");
    }

    const randomIndex = Math.floor(Math.random() * items.length);
    return items[randomIndex];
}
